import { render } from "./ForgotArea.vue?vue&type=template&id=30f4b848&scoped=true"
import script from "./ForgotArea.vue?vue&type=script&lang=js"
export * from "./ForgotArea.vue?vue&type=script&lang=js"

import "./ForgotArea.vue?vue&type=style&index=0&id=30f4b848&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f4b848"]])

export default __exports__